'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import type { VisitorToken } from '@mentimeter/visitor/visitor-token';
import { useRouter } from '@mentimeter/next-navigation';
import { startSocialAuth } from '../../social-auth/startSocialAuth';
import { trackSocialLogin } from '../../utils/trackSocialLogin';
import {
  FacebookTransparentButton,
  GoogleButton,
  MicrosoftButton,
} from './SocialButton';

export const SocialAuthWrapper = ({
  visitorToken,
  disabled,
  referral,
  isSignup,
  continueUrl,
}: {
  visitorToken: VisitorToken | null;
  referral: string;
  disabled: boolean;
  isSignup: boolean;
  continueUrl: string;
}) => {
  const t = useTranslations('authentication.legacy.authPackage');
  const router = useRouter();
  return (
    <>
      <GoogleButton
        onClick={async () => {
          trackSocialLogin(visitorToken, 'google', 'Social SSO started');

          const url = startSocialAuth({
            network: 'google',
            referral,
            continueUrl,
          });
          router.push(url);
        }}
        mb={2}
        disabled={disabled}
      >
        {isSignup ? t('signup_google') : t('login_google')}
      </GoogleButton>
      {!isSignup && (
        <MicrosoftButton
          onClick={async () => {
            trackSocialLogin(visitorToken, 'windows', 'Social SSO started');

            const url = startSocialAuth({
              network: 'windows',
              referral,
              continueUrl,
            });
            router.push(url);
          }}
          mb={2}
          disabled={disabled}
        >
          {t('login_microsoft')}
        </MicrosoftButton>
      )}
      {!isSignup && (
        <FacebookTransparentButton
          onClick={async () => {
            trackSocialLogin(visitorToken, 'facebook', 'Social SSO started');

            const url = startSocialAuth({
              network: 'facebook',
              referral,
              continueUrl,
            });
            router.push(url);
          }}
          mb={2}
          disabled={disabled}
        >
          {t('login_facebook')}
        </FacebookTransparentButton>
      )}
    </>
  );
};
